import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";

import { Coordinate } from "./flux";

const styles = require('./GoogleMap.local.css');

interface Props
{
    className?: string;
    position?: Coordinate;
    defaultZoom: number;
}

export class GoogleMap extends React.Component<Props>
{
    private mapRef: HTMLDivElement;
    private map: google.maps.Map;
    private marker: google.maps.Marker;

    componentDidMount()
    {
        if(!window['google']) {
            throw new Error('you have to add/inject <script src="https://maps.googleapis.com/maps/api/js?key=...></script>');
        }
        this.tryUpdateMap();
    }
    
    render()
    {
        this.tryUpdateMap();
        return (
            <div className={classnames(this.props.className, styles.GoogleMap)} ref={e => {
                this.mapRef = e;
                this.tryUpdateMap();
            }}/>
        );
    }

    private tryUpdateMap ()
    {
        if(!this.mapRef)
            return;
        
        const { position, defaultZoom } = this.props;

        if(!this.isValid(position)) {
            if(this.marker) {
                this.marker.setVisible(false);
            }

            return;
        }
        
        const latLng = { lat: position.lat, lng: position.lon };
        if(!this.map) {
            this.map = new google.maps.Map(this.mapRef, {
                center: latLng,
                zoom: defaultZoom,
            });
        } else {
            const bounds = this.map.getBounds();
            if(!bounds || !bounds.contains(latLng)) {
                this.map.setCenter(latLng);
            }
        }

        if(!this.marker) {
            this.marker = new google.maps.Marker({
                position: latLng,
                map: this.map
            });
        } else {
            this.marker.setPosition(latLng);
            this.marker.setVisible(true);
        }
    }

    isValid(position: Coordinate)
    {
        return (position
            && typeof position.lat === 'number'
            && typeof position.lon === 'number'
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/GoogleMap.tsx